module.exports = __webpack_public_path__ + "img/arrow-line.93bd4952.svg";